import { Typography, Stepper, StepLabel, Step } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';

import { ReactComponent as Group98 } from '../../assets/modalKYX/Group98.svg';

const useStyles = makeStyles({
    banner: {
        backgroundColor: '#F7F9FC !important',
        maxWidth: '16em',
        minWidth: '16em',
        minHeight: '100%',
        padding: '2em 1em 1em 2em'
    },
    bannerTitle: {
        fontWeight: '700!important',
        fontSize: '18px'
    },
    bannerSpan: {
        textOverflow: 'clip'
    },
    bannerStepper: {
        marginTop: '1em'
    },
    steplabel: {
        color: '#1BABE2!important'
    }
});

export const StepBanner = ({ activeStep }) => {
    const classes = useStyles();

    const steps = [
        {
            label: 'Phone Number'
        },
        {
            label: 'Basic Information'
        }
        /*{
      label: "Identification",
    },
    {
      label: "Preview",
    },*/
    ];

    return (
        <Box
            className={classes.banner}
            sx={{
                display: { lg: 'initial', md: 'initial', sm: 'none', xs: 'none' }
            }}>
            <Group98 />
            <Box className={classes.bannerText}>
                <Typography
                    variant="h5"
                    component="h5"
                    className={classes.bannerTitle}
                    sx={{
                        fontWeight: '700',
                        fontSize: '18px'
                    }}>
                    Verify Yourself
                </Typography>
            </Box>
            <Stepper className={classes.bannerStepper} orientation="vertical" activeStep={activeStep - 1}>
                {steps.map((item, index) => {
                    return (
                        <Step key={index}>
                            <StepLabel
                                sx={{
                                    '.MuiStepLabel-label': {
                                        fontSize: '12px',
                                        fontWeight: '700!important',
                                        color: '#7D95A5!important'
                                    },
                                    '.MuiStepIcon-text': {
                                        fill: 'white'
                                    },
                                    '.Mui-active': {
                                        color: '#1BABE2!important'
                                    }
                                }}>
                                {item.label}
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
};
